import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import queryString from 'query-string'

const useSearchQuery = () => {
  const location = useLocation()

  return useMemo(
    () => queryString.parse(location.search) || {},
    [location.search]
  )
}

export default useSearchQuery
